/** Empresas fixas para integração Banrisul (temporário). */
export const FIN_BANRISUL_ID_EMPRESA_CONFIG = 2;

/** E-mail para envio dos 5 testes de homologação em produção (documentação Banrisul). */
export const BANRISUL_EMAIL_HOMOLOGACAO = 'gestao_sistemas_cobranca_operacional@banrisul.com.br';

/**
 * H = sandbox apidev + ambiente T (beneficiário fictício);
 * C = certificação api produção + ambiente T (beneficiário real, retorno 04);
 * P = produção efetiva (ambiente P).
 */
export type BanrisulApiAmbiente = 'H' | 'C' | 'P';

export const BANRISUL_URLS = {
  homologacao: {
    api: 'https://apidev.banrisul.com.br/cobranca/v1/',
    token: 'https://apidev.banrisul.com.br/auth/oauth/v2/token',
  },
  certificacao: {
    api: 'https://api.banrisul.com.br/cobranca/v1/',
    token: 'https://api.banrisul.com.br/auth/oauth/v2/token',
  },
  producao: {
    api: 'https://api.banrisul.com.br/cobranca/v1/',
    token: 'https://api.banrisul.com.br/auth/oauth/v2/token',
  },
} as const;

/**
 * Dados de cobrança para testes no Sandbox / Homologação (API Cobrança v1).
 * @see https://developers.banrisul.com.br/pages/docs/clientes-banrisul/api-cobranca-v1.html#section/Testes/Ambiente-Sandbox
 */
export const BANRISUL_HOMOLOGACAO = {
  /** bergs-beneficiario — Beneficiário OK (testes de sucesso). */
  codigoBeneficiarioCompleto: '0010000001088',
  agencia: '0010',
  codigoBeneficiario: '0000108',
  digitoConta: '88',
  nomeBeneficiarioCobranca: 'Beneficiário OK (Sandbox Banrisul)',
  descricao: 'Banrisul — Homologação (Sandbox)',
} as const;

/** @deprecated use BANRISUL_HOMOLOGACAO */
export const BANRISUL_SANDBOX = BANRISUL_HOMOLOGACAO;

/** Outros beneficiários fictícios do Sandbox (cenários de erro). */
export const BANRISUL_SANDBOX_BENEFICIARIOS_TESTE = [
  { codigo: '0010000001088', descricao: 'Beneficiário OK (sucesso)' },
  { codigo: '0010000027079', descricao: 'Beneficiário desativado' },
  { codigo: '0001000000171', descricao: 'Beneficiário recém criado' },
  { codigo: '0001000000252', descricao: 'Beneficiário sem permissão API' },
  { codigo: '0001000000333', descricao: 'Beneficiário inapto' },
  { codigo: '0001000000414', descricao: 'Beneficiário inexistente' },
] as const;
